import * as Event from '../tools/Event';
import { fontLoader } from './fontFaceObserver';
import { addClass, removeClass, append, remove, createElement, wrap } from '../tools/DOM';
import throttle from 'lodash.throttle';


export const init = () => {
	const elements = [...document.querySelectorAll('.table-responsive')];

	const prepare = (element) => {
		const LEFT_SCROLLABLE_CLASS = 'is-left-scrollable';
		const RIGHT_SCROLLABLE_CLASS = 'is-right-scrollable';
		const table = element.querySelector('table');
		const holder = createElement('div', 'table-responsive__holder');
		const gradientLeft = createElement('div', 'table-responsive__gradient table-responsive__gradient--left');
		const gradientRight = createElement('div', 'table-responsive__gradient table-responsive__gradient--right');
		let isInit = false;

		const init = () => {
			if (isInit) return;

			checkTable();

			isInit = true;
		};

		const update = () => {
			const holderWidth = holder.offsetWidth;
			const tableWidth = table.offsetWidth;

			if (tableWidth > holderWidth) {
				init();
			} else {
				destroy();
			}

			checkTable();
		};

		const destroy = () => {
			if (!isInit) return;

			removeClass(element, LEFT_SCROLLABLE_CLASS);
			removeClass(element, RIGHT_SCROLLABLE_CLASS);
			remove(gradientLeft);
			remove(gradientRight);

			isInit = false;
		};

		const checkTable = () => {
			if (!isInit) return;

			const maxScroll = holder.scrollWidth - holder.clientWidth;
			const currentScroll = holder.scrollLeft;

			if (currentScroll <= 0) {
				removeClass(element, LEFT_SCROLLABLE_CLASS);
				remove(gradientLeft);
			} else {
				addClass(element, LEFT_SCROLLABLE_CLASS);
				append(gradientLeft, element);
			}

			if (currentScroll >= maxScroll) {
				removeClass(element, RIGHT_SCROLLABLE_CLASS);
				remove(gradientRight);
			} else {
				addClass(element, RIGHT_SCROLLABLE_CLASS);
				append(gradientRight, element);
			}
		};


		wrap(table, holder);

		fontLoader.then(() => update());

		Event.on(window, 'resize', throttle(update, 100));
		Event.on(holder, 'scroll', throttle(checkTable, 100));
	};


	elements.forEach(prepare);
};



// WEBPACK FOOTER //
// ./src/js/components/tableResponsive.js